import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function CollectorTenantsButton({ user, tenants, onDone }) {
  const [open, setOpen] = useState(false);
  const cur = user.assigned_tenants || [];
  const [sel, setSel] = useState(new Set(cur));
  useEffect(() => {
    if (open) setSel(new Set(cur));
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (id) => setSel((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const save = async () => {
    try {
      await api.put(`/admin/users/${user.id}/collector-tenants`, { tenants: [...sel] });
      toast.success("Penugasan petugas disimpan & tercatat di audit log");
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => setOpen(true)} data-testid={`collector-tenants-btn-${user.username}`}>Ditugaskan: {cur.length} perusahaan</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="collector-tenants-dialog">
          <DialogHeader>
            <DialogTitle>Penugasan Petugas · {user.username}</DialogTitle>
            <DialogDescription>Petugas penarikan hanya bisa masuk ke perusahaan yang dicentang.</DialogDescription>
          </DialogHeader>
          <div className="max-h-72 overflow-y-auto space-y-1 border rounded-sm p-2">
            {tenants.map((t) => (
              <label key={t.id} className="flex items-center gap-2 text-sm py-1.5">
                <Checkbox checked={sel.has(t.id)} onCheckedChange={() => toggle(t.id)} className="h-5 w-5" data-testid={`collector-tenant-${t.nota_code || t.id}`} />{t.name}
              </label>
            ))}
          </div>
          <DialogFooter><Button onClick={save} className="h-11 bg-emerald-700 hover:bg-emerald-800" data-testid="collector-tenants-save">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
